import { apiFetch } from "@/lib/api/client";
import type { AdminBootstrap, BootstrapResponse } from "@/lib/types/session";

/**
 * `email` ist der Anmeldename — E-Mail-Adresse oder, für Mitglieder ohne
 * Adresse, der Benutzername aus dem Onboarding (S1.6). Der Benutzername ist nur
 * innerhalb seines Mandanten eindeutig, deshalb `tenant` (die Mandantenkennung)
 * dazu; für Adressen bleibt es leer.
 */
export function login(email: string, password: string, tenant = ""): Promise<BootstrapResponse> {
  return apiFetch<BootstrapResponse>("/auth/login", {
    method: "POST",
    body: JSON.stringify({ email, password, tenant })
  });
}

export function activateCustomer(token: string): Promise<BootstrapResponse> {
  return apiFetch<BootstrapResponse>("/auth/customer/activate", {
    method: "POST",
    body: JSON.stringify({ token })
  });
}

export function logout(): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>("/auth/logout", { method: "POST" });
}

export type EndImpersonationResponse = { ok: true; session: null } | AdminBootstrap;

export function endImpersonation(): Promise<EndImpersonationResponse> {
  return apiFetch<EndImpersonationResponse>("/auth/end-impersonation", { method: "POST" });
}

export function requestPasswordReset(email: string): Promise<{ ok: true; message: string }> {
  return apiFetch<{ ok: true; message: string }>("/auth/forgot", {
    method: "POST",
    body: JSON.stringify({ email })
  });
}

export function resetPassword(token: string, password: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>("/auth/reset", {
    method: "POST",
    body: JSON.stringify({ token, password })
  });
}

export function changePassword(password: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>("/auth/change-password", {
    method: "POST",
    body: JSON.stringify({ password })
  });
}
